var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackward2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 19,
    height: 19,
    transform: "rotate(-180 36 20)",
    stroke: "black",
    strokeWidth: 1.60714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38889 18L2 10.5781M2 10.5781L9.38889 3.15625M2 10.5781L18.0313 10.5781",
    stroke: "black",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M30.9736 16.5625H22.2021V14.8223L26.3418 10.4102C26.9102 9.78906 27.3291 9.24707 27.5986 8.78418C27.874 8.32129 28.0117 7.88184 28.0117 7.46582C28.0117 6.89746 27.8682 6.45215 27.5811 6.12988C27.2939 5.80176 26.8838 5.6377 26.3506 5.6377C25.7764 5.6377 25.3223 5.83692 24.9883 6.23535C24.6602 6.62793 24.4961 7.14649 24.4961 7.79102H21.9473C21.9473 7.01172 22.1318 6.29981 22.501 5.65527C22.876 5.01074 23.4033 4.50684 24.083 4.14356C24.7627 3.77442 25.5332 3.58985 26.3945 3.58985C27.7129 3.58985 28.7354 3.90625 29.4619 4.53906C30.1943 5.17188 30.5605 6.06543 30.5605 7.21973C30.5605 7.85254 30.3965 8.49707 30.0684 9.15332C29.7402 9.80957 29.1777 10.5742 28.3809 11.4473L25.4717 14.5146H30.9736V16.5625Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackward2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Backward2.f55dd98ea20360284ee1da81530cbbc4.svg";